// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__B+YaR","spinnerWrapper":"Spinner_spinnerWrapper__OF8T+"};